import React from 'react'
import SearchResults from '../Components/SearchResults/SearchResults'
import Sidenav from '../Components/Sidenav/Sidenav'

const Results = () => {
    return (
        
        <section className="main-container col2-left-layout bounceInUp animated">
            <div className="container">
                <div className="row">
                    <Sidenav/>
                    <SearchResults />
                </div>
            </div>
        </section>
    )
}

export default Results
